import {
    ADD_SURVEY_WELCOME,
    EDIT_SURVEY_WELCOME,
    LIST_SURVEY_WELCOME,
    VIEW_SURVEY_WELCOME,
    DELETE_SURVEY_WELCOME,

    SURVEY_WELCOME_SUCCESS,
    SURVEY_WELCOME_ERROR,
  
  } from "./actionTypes"
  const initialState = {
    successMsg: null,
    error: null,
    editLoading:false
  }
  
  const configSurveyWelcome = (state = initialState, action) => {
    switch (action.type) {
  
      // add SURVEY_WELCOME
      case ADD_SURVEY_WELCOME:
        state = {
          ...state,
          editLoading: true,
          successMsg: null,
          error: null,
        }
        break
      case SURVEY_WELCOME_SUCCESS:
        state = {
          ...state,
          loading: false,
          successMsg: action.payload,
          editLoading:false
        }
        break
      case SURVEY_WELCOME_ERROR:
        state = { ...state, error: action.payload, loading: false, editLoading:false}
        break
  
      // edit SURVEY_WELCOME
      case EDIT_SURVEY_WELCOME:
        state = {
          ...state,
          editLoading: true,
          successMsg: null,
          error: null,
        }
        break
  
      // list SURVEY_WELCOME
      case LIST_SURVEY_WELCOME:
        state = {
          ...state,
          loading: true,
          successMsg: null,
          error: null,
        }
        break
  
      // view SURVEY_WELCOME
      case VIEW_SURVEY_WELCOME:
        state = {
          ...state,
          successMsg: null,
          error: null,
        }
        break
  
      // delete SURVEY_WELCOME
      case DELETE_SURVEY_WELCOME:
        state = {
          ...state,
          loading: true,
          successMsg: null,
          error: null,
        }
        break

      default:
        state = { ...state }
        break
    }
    return state
  }
  
  export default configSurveyWelcome
  